import React, { createContext, useContext, useState, useEffect } from 'react';

export const AnalogsDataContext = createContext();

export function AnalogsDataProvider({ children }) {
  const [analogsData, setAnalogsData] = useState({});
  const PATH_TO_BACKEND = process.env.REACT_APP_PATH_TO_BACKEND;

  useEffect(() => {
    const fetchAnalogsData = async () => {
      try {
        const response = await fetch(`${PATH_TO_BACKEND}/api/analogs-data`);
        const result = await response.json();
        if (result.success && result.data) {
          setAnalogsData(result.data);
        } else {
          console.warn('Failed to load analogs data:', result.message);
        }
      } catch (error) {
        console.error('Error fetching analogs data:', error);
      }
    };

    fetchAnalogsData();
  }, []);

  return (
    <AnalogsDataContext.Provider value={{ analogsData, setAnalogsData }}>
      {children}
    </AnalogsDataContext.Provider>
  );
}

export const useAnalogsData = () => useContext(AnalogsDataContext);